export const ANTIFRAUD_ACTIONS = {
    ANTIFRAUD_ONFIDO_ID: 1,
    ANTIFRAUD_ADDITIONAL_INFO_ID: 2,
    ANTIFRAUD_PURPOSE_TRANSFER_ID: 3,
    ANTIFRAUD_RECIPIENT_DETAILS: 4,
    ANTIFRAUD_CARD_VALIDATION_ID: 5,
    ANTIFRAUD_RELATIONSHIP_AND_SPLITTING_ID: 6,
    ANTIFRAUD_SOURCE_OF_INCOME_ID: 7,
    ANTIFRAUD_RECIPIENT_RELATIONSHIP_ID: 8,
    ANTIFRAUD_RECIPIENT_ONFIDO_FLOW: 9,
    ANTIFRAUD_SOURCE_OF_FUNDS_ID: 10,
    ANTIFRAUD_INCREASE_LIMITS_ID: 13,
    ANTIFRAUD_INCORRECT_ADDRESS_ID: 12,
} as const;

export type AntifraudActionKey = keyof typeof ANTIFRAUD_ACTIONS;
export type AntifraudActionValue = (typeof ANTIFRAUD_ACTIONS)[AntifraudActionKey];

export const {
    ANTIFRAUD_ONFIDO_ID,
    ANTIFRAUD_ADDITIONAL_INFO_ID,
    ANTIFRAUD_PURPOSE_TRANSFER_ID,
    ANTIFRAUD_RECIPIENT_DETAILS,
    ANTIFRAUD_CARD_VALIDATION_ID,
    ANTIFRAUD_RELATIONSHIP_AND_SPLITTING_ID,
    ANTIFRAUD_SOURCE_OF_INCOME_ID,
    ANTIFRAUD_RECIPIENT_RELATIONSHIP_ID,
    ANTIFRAUD_RECIPIENT_ONFIDO_FLOW,
    ANTIFRAUD_SOURCE_OF_FUNDS_ID,
    ANTIFRAUD_INCREASE_LIMITS_ID,
    ANTIFRAUD_INCORRECT_ADDRESS_ID,
} = ANTIFRAUD_ACTIONS;
